/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

export const firebaseConfig = {
  projectId: "nyrenehaquemd",
  appId: "1:121817195870:web:03c79fb499e4e5d90ddbcf",
  storageBucket: "nyrenehaquemd.firebasestorage.app",
  apiKey: "AIzaSyBpehhe4jPXB-zcGyZVT2QD1i_cx5v6L5M",
  authDomain: "nyrenehaquemd.firebaseapp.com",
  messagingSenderId: "121817195870",
  measurementId: "G-4F9GCHFEV6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics only if in browser environment
export const analytics = typeof window !== "undefined" ? getAnalytics(app) : null;
export default app;
